//import 'materialize-css/dist/css/materialize.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import App from './App';
import reducers from './reducers';
import { GoogleOAuthProvider } from '@react-oauth/google';

import registerServiceWorker from './registerServiceWorker';
// for Flage Icon
import 'flag-icons/css/flag-icons.min.css'; 

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

// ✅ Read from .env
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

ReactDOM.render(
<Provider store={store}>
    <GoogleOAuthProvider clientId={googleClientId}>
        <App />
    </GoogleOAuthProvider>
</Provider>, document.getElementById('root'));
//ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
